@if (!(hasLoaded || loadFailureMessage)) {
  <div class="loading">
    <sb-icon name="loading"></sb-icon> <span [innerHtml]="(message || 'SB_Loading') | translate"></span>
  </div>
}
@if (loadFailureMessage) {
  <sb-alert
    class="col-xs-12"
    alertClass="danger"
    [message]="loadFailureMessage">
  </sb-alert>
}